'use strict';

var debounce = require('lodash/debounce');
var endpoint = $('.suggestions-wrapper').data('url');
var minChars = 3;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings('.suggestions-wrapper');
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $('input.search-field').val('');
    $('body').removeClass('modal-open');
    $('header').siblings().attr('aria-hidden', 'false');
    $('.suggestions').removeClass('modal');
    $('.search-mobile .suggestions').off('scroll');
    $('.suggestions-wrapper').empty();
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
        $suggestions.css('top', top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();

    $.spinner().stop();
    var searchPhrase = $('input.search-field').val();

    if (typeof (response) !== 'object') {
        $('.js-search-flyout-noresults').hide();
        $suggestionsWrapper.append(response).show();
        showSearchSuggestions(this);
        if (searchPhrase.length > 0) {
            var searchPhraseRegEx = new RegExp('(' + searchPhrase + ')', 'gi');
            $suggestionsWrapper.find('.js-search-term').each(function () {
                var $this = $(this);
                $this.html($this.html().replace(searchPhraseRegEx, '<strong>$1</strong>'));
            });
        }

        $(this).siblings('.reset-button').addClass('d-sm-block');
        positionSuggestions(this);
        var suggestionsList = $('.suggestions .item');
        if ($(suggestionsList).length) {
            $('input.search-field').attr('aria-describedby', 'search-result-count');
        } else {
            $('input.search-field').removeAttr('aria-describedby');
        }
    } else {
        $suggestionsWrapper.hide();
        $('.js-search-keyword').text('"' + searchPhrase + '"')
        $('.js-search-flyout-noresults').show();
        hideSearchSuggestions(this);
    }
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest('.search-mobile').length;
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $('.more-below').fadeOut();
    } else {
        $('.more-below').fadeIn();
    }
}

/**
 * Show suggestions and update ARIA attributes correctly
 */
function showSearchSuggestions(scope) {
    const $input = $(scope);
    const $results = getSuggestionsWrapper(scope);

    $input.attr('aria-expanded', 'true');
    $results.removeAttr('hidden');
}

/**
 * Hide suggestions and update ARIA attributes correctly
 */
function hideSearchSuggestions(scope) {
    const $input = $(scope);
    const $results = getSuggestionsWrapper(scope);

    $input.attr('aria-expanded', 'false');
    $results.attr('hidden', 'true');
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: 'GET',
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        $(scope).siblings('.reset-button').removeClass('d-sm-block');
        getSuggestionsWrapper(scope).empty();
        hideSearchSuggestions(scope);
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    var suggestionsList = $('.suggestions .item');
    if (suggestionsList.filter('.selected').length === 0) {
        suggestionsList.first().addClass('selected');
        $('input.search-field').each(function () {
            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(this).removeAttr('aria-selected');
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass('selected');
                    suggestionsList.eq(idx).attr('aria-selected', true);
                    $(this).removeProp('aria-selected');
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass('selected');
                    suggestionsList.first().attr('aria-selected', true);
                    $('input.search-field').each(function () {
                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    $('form[name="simpleSearch"]').on('submit', function (e) {
        if (!$(this).find('.search-field').val().trim()) {
            e.preventDefault();
            return;
        }
        var suggestionsList = $('.suggestions .item');
        if (suggestionsList.filter('.selected').length !== 0) {
            e.preventDefault();
            suggestionsList.filter('.selected').find('a')[0].click();
        }
    });

    $('input.search-field').each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on('keyup focus', function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case 27:
                    hideSearchSuggestions(this);
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $('body').on('click', function (e) {
        if (!document.querySelector('.suggestions')) return;
        if (!$('.suggestions').has(e.target).length && !$(e.target).hasClass('search-field')) {
            $('.suggestions').hide();
            hideSearchSuggestions($('.search-field'));
        }
    });

    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
    });

    let searchTrigger = null;

    $('.js-search-flyout').on('show.bs.modal', function (e) {
        // Capture trigger before changing focus, so we can restore it on close.
        // modal.js also reads document.activeElement here (for keyboard users),
        // but our input.focus() below would corrupt it — we own the focus return
        // for this modal and modal.js will be a no-op (lastFocusedBeforeModal stays null).
        searchTrigger = e.relatedTarget || document.activeElement || null;

        // show.bs.modal fires synchronously within the user's click call stack,
        // before Bootstrap's async animation. Forcing display:block here is the
        // only reliable way to call focus() while iOS/Android still consider it
        // a direct user gesture, so the virtual keyboard appears on real devices.
        this.style.display = 'block';
        const input = this.querySelector('.search-field');
        if (input) {
            const $keyword = $('.js-search-keyword-inpage');
            const $keywordfounded = $('.js-search-keyword-founded');
            if ($keyword.length) {
                input.value = $keyword.text().replace(/^"|"$/g, '').trim();
            } else if ($keywordfounded.length && $keywordfounded.text() !== '') {
                input.value = $keywordfounded.text().replace(/^"|"$/g, '').trim();
            }
            input.focus();
        }
    });

    $('.js-search-flyout').on('shown.bs.modal', function () {
        const modal = this;
        // setTimeout(0) runs after all synchronous shown.bs.modal handlers,
        // including modal.js which moves focus to the modal div for keyboard users.
        // The activeElement guard prevents a second focus() call on mobile/mouse,
        // where input is already focused from show.bs.modal and modal.js did nothing.
        setTimeout(function () {
            const input = modal.querySelector('.search-field');
            if (input && document.activeElement !== input) {
                input.focus();
            }
        }, 0);
    });

    $('.js-search-flyout').on('hidden.bs.modal', function () {
        if (searchTrigger && document.body.contains(searchTrigger)) {
            $(searchTrigger).trigger('focus');
        }
        searchTrigger = null;

        $('.suggestions').hide();
        tearDownSuggestions();
    });
};
